module.exports = __webpack_public_path__ + "img/Guernsey.964dbd35.svg";